import { html } from "@nodusjs/std/dom";

export const component = () => html`<slot></slot>`;
